<template>
  <div class="free-trail-wrap">
    <van-icon name="close" class="close" size="24" @click="closeFreeTrial" />
    <div class="title">欢迎您申请{{ $global.siteName }}的试用</div>
    <InputWithLabel
      class="input fr"
      inpid="name"
      label="姓名"
      :valueRequire="true"
      :valueInvalid="submitParamsInvalid.name"
      :hasIcon="true"
      :inpValue="submitParams.name"
      @changeInpValue="changeXm"
    >
    </InputWithLabel>
    <!--<InputWithLabel
      class="input fr"
      inpid="alias"
      label="称谓"
      :valueRequire="false"
      :hasIcon="true"
      :inpValue="submitParams.alias"
      @changeInpValue="changeCw"
    >
    </InputWithLabel>-->
    <InputWithLabel
      class="input fr"
      inpid="phone"
      label="手机号"
      :valueRequire="true"
      :valueInvalid="submitParamsInvalid.phone"
      :hasIcon="true"
      :inpValue="submitParams.phone"
      :reg="phoneReg"
      @changeInpValue="changeTel"
    >
    </InputWithLabel>
    <InputWithLabel
      class="input fr"
      inpid="company"
      label="公司"
      :valueRequire="true"
      :valueInvalid="submitParamsInvalid.company"
      :hasIcon="true"
      :inpValue="submitParams.company"
      @changeInpValue="changeCompany"
    >
    </InputWithLabel>
    <InputWithLabel
      class="input fr"
      inpid="position"
      label="职位"
      :valueRequire="true"
      :valueInvalid="submitParamsInvalid.position"
      :hasIcon="true"
      :inpValue="submitParams.position"
      @changeInpValue="changeZw"
    >
    </InputWithLabel>
    <div class="sub-title">您公司所处行业<span class="require">*</span></div>
    <span class="error-msg require" v-if="submitParamsInvalid.industry">{{
      industryInvalidMsg
    }}</span>
    <CheckboxGroup
      class="checkbox-wrap"
      v-model="industry"
      @on-change="changeOtherIndustry"
    >
      <div class="checkbox">
        <Checkbox label="快消品">快消品</Checkbox>
      </div>
      <div class="checkbox">
        <Checkbox label="食品饮料">食品饮料</Checkbox>
      </div>
      <div class="checkbox">
        <Checkbox label="医药">医药</Checkbox>
      </div>
      <div class="checkbox">
        <Checkbox label="机械制造">机械制造</Checkbox>
      </div>
      <div class="checkbox">
        <Checkbox label="电子电器">电子电器</Checkbox>
      </div>
      <div class="checkbox">
        <Checkbox label="其他"
          >其他<input type="text" v-model="otherIndustry"
        /></Checkbox>
      </div>
    </CheckboxGroup>
    <Button class="submit-btn" @click="submit">提交</Button>
    <MyLoading msg="加载中，请稍后..." ref="myLoading"></MyLoading>
  </div>
</template>

<script>
import "../assets/javascript/vant";
import InputWithLabel from "./InputWithLabel.vue";
import MyLoading from "./MyLoading.vue";
import { cloneObj } from "../assets/javascript/utils.js";
import getData from "../service/getData";
import api from "../service/api";

export default {
  data() {
    return {
      phoneReg: /^1[3-9]\d{9}$/,
      industry: [],
      industryCopy: [],
      otherIndustry: "",
      submitParamsInvalid: {
        // 提交字段合法性
        name: false,
        alias: false,
        phone: false,
        company: false,
        position: false,
        industry: false
      },
      submitParams: {
        name: "",
        alias: "",
        phone: "",
        company: "",
        position: "",
        industry: ""
      }
    };
  },
  computed: {
    // 所处行业非法提示信息
    industryInvalidMsg() {
      if (this.industry.length === 0) {
        return "请选择您公司所处行业";
      } else if (
        this.industry.indexOf("其他") > -1 &&
        this.otherIndustry.length === 0
      ) {
        return "请输入您公司所处其他行业";
      }
    }
  },
  watch: {
    // 所处行业 - 其他 是否填写
    otherIndustry(v) {
      if (this.industry.indexOf("其他") > -1 && v.length > 0) {
        this.submitParamsInvalid.industry = false;
      }
    }
  },
  methods: {
    closeFreeTrial() {
      this.$emit("closeFreeTrial");
    },
    // 修改姓名
    changeXm(v) {
      this.submitParams.name = v;
      if (v.length > 0) {
        this.submitParamsInvalid.name = false;
      }
    },
    // 修改称谓
    changeCw(v) {
      this.submitParams.alias = v;
    },
    // 修改电话
    changeTel(v) {
      this.submitParams.phone = v;
      if (v.length > 0 && this.phoneReg.test(v)) {
        this.submitParamsInvalid.phone = false;
      }
    },
    // 修改公司
    changeCompany(v) {
      this.submitParams.company = v;
      if (v.length > 0) {
        this.submitParamsInvalid.company = false;
      }
    },
    // 修改职位
    changeZw(v) {
      this.submitParams.position = v;
      if (v.length > 0) {
        this.submitParamsInvalid.position = false;
      }
    },
    //  修改行业数组
    changeOtherIndustry(v) {
      if (v.indexOf("其他") === -1) {
        // 清空其他行业输入内容
        this.otherIndustry = "";
        this.submitParamsInvalid.industry = false;
      }
    },
    // 提交
    async submit() {
      // 定义非法字符数量
      let invalidNum = 0;
      if (this.submitParams.name.length === 0) {
        invalidNum++;
        this.submitParamsInvalid.name = true;
      }
      if (
        this.submitParams.phone.length === 0 ||
        !this.phoneReg.test(this.submitParams.phone)
      ) {
        invalidNum++;
        this.submitParamsInvalid.phone = true;
      }
      if (this.submitParams.company.length === 0) {
        invalidNum++;
        this.submitParamsInvalid.company = true;
      }
      if (this.submitParams.position.length === 0) {
        invalidNum++;
        this.submitParamsInvalid.position = true;
      }
      if (this.industry.length === 0) {
        invalidNum++;
        this.submitParamsInvalid.industry = true;
      } else {
        // 用于最终的行业字段，与选择交互分离
        this.industryCopy = cloneObj(this.industry);
        if (this.industry.indexOf("其他") > -1) {
          // 选择了'其他'，必须输入内容
          if (this.otherIndustry.length === 0) {
            invalidNum++;
            this.submitParamsInvalid.industry = true;
            return;
          }
          // 将'其他'替换为输入的内容
          this.industryCopy.splice(
            this.industryCopy.indexOf("其他"),
            1,
            this.otherIndustry
          );
          this.submitParamsInvalid.industry = false;
        }
        this.submitParams.industry = this.industryCopy.join(";");
      }

      if (invalidNum > 0) return;

      this.$refs.myLoading.show();
      let params = this.submitParams;
      params.alias = this.$global.siteName;
      const res = await getData.postJson(api.applyTrial, params);
      this.$refs.myLoading.hide();
      if (res && res.data && res.data.code === 0) {
        this.$emit("success");
      }
    }
  },
  components: {
    InputWithLabel,
    MyLoading
  }
};
</script>

<style lang="scss">
.free-trail-wrap {
  width: 37%;
  min-width: 480px;
  max-width: 600px;
  height: 56%;
  min-height: 550px;
  max-height: 648px;
  background: #ffffff;
  background-clip: padding-box;
  box-shadow: 0px 2px 4px 5px rgba(101, 101, 101, 0.2);
  border-radius: 10px;
  padding: 30px 10px 0 40px;
  overflow: auto;
  font-family: PingFangSC-Semibold;
  position: relative;
  .close {
    display: none;
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .title {
    font-size: 18px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
  }
  .input {
    width: 100%;
    margin-top: 22px;
  }
  .sub-title {
    float: left;
    width: 100%;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-top: 28px;
  }
  .checkbox-wrap {
    .checkbox {
      margin-top: 18px;
      width: 30%;
      margin-right: 0;
      float: left;
      &:last-of-type {
        width: 40%;
        input {
          width: 60%;
          border: none;
          margin-left: 4px;
          padding: 0 2px;
          border-bottom: 1px solid #0057ff;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .ivu-checkbox-inner {
    width: 14px;
    height: 14px;
    border: none;
    background-image: url("/static/images/unselected.png");
    background-repeat: no-repeat;
    background-size: 14px 14px;
    &::after {
      display: none;
    }
  }
  .ivu-checkbox-checked {
    .ivu-checkbox-inner {
      border-color: transparent;
      background-color: transparent;
      background-image: url("/static/images/selected.png");
    }
  }
  .submit-btn {
    width: 120px;
    height: 40px;
    color: #fff;
    background: #0057ff;
    border-radius: 25px;
    margin-top: 30px;
    overflow: hidden;
    margin-bottom: 30px;
    &:hover {
      color: #fff;
      background: #0057ff;
      border-color: #0057ff;
    }
  }
}
@media screen and (max-width: 768px) {
  .static-wrap {
    .free-trail-wrap {
      min-width: 100%;
      height: 100%;
      max-height: 100%;
      border-radius: 0;
      padding-top: 70px;
      .close {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FreeTrial.vue